import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../LanguageContext';

const Section = styled.section.attrs({ id: 'blog' })`
  padding: 4rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grayDark};
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2rem;
  margin-bottom: 3rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.greenPrimary};
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const Card = styled.article`
  background-color: ${({ theme }) => theme.colors.grayLight};
  border-radius: 10px;
  padding: 1rem;
  flex: 1 1 300px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
`;

const ArticleImage = styled.img`
  width: 100%;
  height: 150px;
  border-radius: 6px;
  margin-bottom: 1rem;
  object-fit: cover;
  object-position: center;
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.colors.blueLight};
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const Teaser = styled.p`
  font-size: 1rem;
  margin-bottom: 1rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  flex-grow: 1;
`;

const Meta = styled.div`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.grayDark};
  margin-bottom: 1rem;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const Button = styled.a`
  text-decoration: none;
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.greenPrimary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  border-radius: 30px;
  transition: background-color 0.3s ease;
  align-self: flex-start;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueLight};
  }
`;

const Blog = () => {
  const { translations } = useLanguage();

  return (
    <Section>
      <Title>{translations.blog.title}</Title>
      <CardsContainer>
        {translations.blog.articles.map((article) => (
          <Card key={article.title}>
            <ArticleImage src={article.image} alt={article.imageLabel} />
            <CardTitle>{article.title}</CardTitle>
            <Teaser>{article.teaser}</Teaser>
            <Meta>{article.date} | {article.category}</Meta>
            <Button 
              href={article.url} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {article.button}
            </Button>
          </Card>
        ))}
      </CardsContainer>
    </Section>
  );
};

export default Blog;
